import { render, staticRenderFns } from "./CollectionTable.vue?vue&type=template&id=e1160a2c"
import script from "./CollectionTable.vue?vue&type=script&lang=js"
export * from "./CollectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports